import * as React from "react";
import classNames from "classnames";

import { mapTypeToIcon } from "../../../Helpers/mapping";

type OutotecIconsProps = {
    type: string;
    classNames?: string;
};

export const OutotecIcons: React.FC<OutotecIconsProps> = (props) => {
    if (props.type === undefined) {
        return <div></div>;
    }

    const href: string = mapTypeToIcon(props.type);
    if (href === "") {
        return <div></div>;
    }
    const iconClass: string = classNames(
        `Icon Icon--${props.type}`,
        props.classNames ? props.classNames : ""
    );
    return (
        <svg className={iconClass} role="img" aria-hidden="true">
            <use xlinkHref={"#" + href} />
        </svg>
    );
};
